export const performanceCardStyles = {
  wrapper: {
    width: "100%",
    "& table": {
      width: "100% !important",
      tableLayout: "fixed !important",
      fontSize: "13px",
      color: "rgb(89, 89, 89)",
    },
    // Colunas
    "& .qv-st-columns col": {
      "&:nth-child(1)": { width: "250px !important" }, // Positivação Total
      "&:nth-child(2)": { width: "40px !important" }, // Ícone de busca
      "&:nth-child(3)": { width: "120px !important" }, // Meta
      "&:nth-child(4)": { width: "120px !important" }, // Realizado
      "&:nth-child(5)": { width: "120px !important" }, // % Atingimento
      "&:nth-child(6)": { width: "auto !important" }, // Última coluna vazia
    },
    // Cabeçalho
    "& .qv-st-header-cell": {
      padding: "8px",
      fontWeight: "bold",
      borderBottom: "1px solid #eee",
      backgroundColor: "#f5f5f5",
    },
    // Células
    "& .qv-st-data-cell-dimension-value": {
      textAlign: "left !important",
      width: "200px !important",
    },
    "& .qv-st-data-cell-numeric": {
      textAlign: "right !important",
      width: "120px !important",
    },
    "& .qv-st-data-cell": {
      padding: "8px",
      borderBottom: "1px solid #eee",
      "& .qv-st-value": {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      },
    },
    // Elementos específicos
    "& .qv-st-header-cell-search": {
      width: "40px !important",
    },
    "& [headers='xmEV-header--10']": {
      width: "auto !important",
    },
    // Interatividade
    "& .qv-st-data-row:hover": {
      backgroundColor: "rgba(0,0,0,0.02)",
    },
  },
  totalTable: {
    width: "100%",
    height: "100px",
    overflow: "hidden",
    marginBottom: 0,
    borderBottom: "1px solid #eee",
  },
  categoriesTable: {
    width: "100%",
    height: "420px",
    overflow: "auto",
  },
};
